import * as React from 'react';

import { Color } from '../../../core/enums/Color';
import Icon from '../../icon/Icon';
import { Icon as IconObject } from '../../../core/constants/Icon';

import './Button.scss';

export type ButtonType =
  | 'small'
  | 'extra-small'
  | 'xx-small'
  | 'red'
  | 'blue'
  | 'white'
  | 'blue-outline'
  | 'red-outline'
  | 'transparent'
  | 'primary'
  | 'outline'
  | 'icon'
  | 'border-icon'
  | 'block';

interface Props {
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  buttonTypes?: ButtonType[];
  onClick?: (e: React.MouseEvent) => void;
  color?: Color;
  disabled?: boolean;
  form?: string;
  icon?: keyof typeof IconObject;
  iconLeft?: boolean;
}

const Button: React.FC<Props> = ({
  type = 'button',
  buttonTypes = ['small'],
  onClick,
  className = '',
  children,
  disabled = false,
  form,
  color,
  icon,
  iconLeft
}) => (
  <button
    type={type}
    onClick={onClick}
    className={`button button--color-${color} ${buttonTypes.map((item) => ` button--${item}`).join('')} ${className}`}
    disabled={disabled}
    form={form}
  >
    {icon && iconLeft && (
      <div className="button__icon button__icon--left">
        <Icon icon={icon} size="full-size" svg />
      </div>
    )}
    {children}
    {icon && !iconLeft && (
      <div className="button__icon">
        <Icon icon={icon} size="full-size" svg />
      </div>
    )}
  </button>
);

export default Button;
